let countdownInterval: NodeJS.Timeout;

function init() {
    const counters = document.querySelectorAll('.js-sale-counter');

    counters.forEach((counter) => {
        const endDateTimestamp = parseInt(counter.dataset.endDate, 10);
        const dayCounter = counter.querySelector('.js-counter-day');
        const hourCounter = counter.querySelector('.js-counter-hour');
        const minuteCounter = counter.querySelector('.js-counter-minute');
        const slideContent = counter.closest('.actions-slider-slide__content');
        const saleEndTitle = slideContent?.querySelector('.js-sale-title');

        function updateCountdown() {
            const now = Date.now();
            const nowSeconds = Math.floor(now / 1000);
            const timeLeft = Math.max(0, endDateTimestamp - nowSeconds);

            const days = Math.floor(timeLeft / (24 * 60 * 60));
            const hours = Math.floor((timeLeft % (24 * 60 * 60)) / (60 * 60));
            const minutes = Math.floor((timeLeft % 3600) / 60);

            if (dayCounter && hourCounter && minuteCounter) {
                dayCounter.textContent = days.toString();
                hourCounter.textContent = hours.toString();
                minuteCounter.textContent = minutes.toString();
            }

            if (timeLeft <= 0) {
                clearInterval(countdownInterval);
                if (saleEndTitle) {
                    counter.classList.add('is-hidden')
                    saleEndTitle.classList.remove('.is-hidden')
                }
            }
        }

        countdownInterval = setInterval(updateCountdown, 60000);
        updateCountdown();
    });
}

function destroy() {
    clearInterval(countdownInterval);
}

const _module = { init, destroy };

export default _module;
